import { Navigate } from 'react-router-dom';
import { isPhoneDeviceNow } from './isMobileDevice';
import { PwaInstallLanding } from './PwaInstallLanding';

/**
 * Ruta `/pwa` de la plataforma web: la landing "Instalá la app" (la misma que reemplaza a la web en un celular).
 *
 * En DESKTOP redirige a la app. No es un detalle: una PWA instalada en Windows o Mac antes de que el
 * `start_url` pasara de `/pwa` a `/` conserva el viejo y reabre en esta ruta; sin la redirección esa
 * persona vería la vista de celular en su computadora.
 */
export function PwaPreviewRoute() {
  if (!isPhoneDeviceNow()) return <Navigate to="/" replace />;
  return <PwaInstallLanding />;
}
